var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.75V14.25C16.5 12.8521 15.5439 11.6776 14.25 11.3445M11.625 2.46807C12.7244 2.91311 13.5 3.99098 13.5 5.25C13.5 6.50902 12.7244 7.58692 11.625 8.0319M12.75 15.75C12.75 14.3521 12.75 13.6533 12.5216 13.102C12.2171 12.3669 11.6331 11.7829 10.898 11.4784C10.3467 11.25 9.64785 11.25 8.25 11.25H6C4.60217 11.25 3.90326 11.25 3.35195 11.4784C2.61686 11.7829 2.03285 12.3669 1.72836 13.102C1.5 13.6533 1.5 14.3521 1.5 15.75M10.125 5.25C10.125 6.90686 8.78183 8.25 7.125 8.25C5.46814 8.25 4.125 6.90686 4.125 5.25C4.125 3.59314 5.46814 2.25 7.125 2.25C8.78183 2.25 10.125 3.59314 10.125 5.25Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.b63a9dc3bbbf3e2a0578634b79ae95f1.svg";
export { ForwardRef as ReactComponent };